import scrollTo from '../helpers/scrollTo';
import gsap from 'gsap';
import customPageScroll from '../components/custom-scroll';

export default () => {
	const wrapper = document.querySelector('.js-contact-scroll-to-wrapper');
	if (!wrapper) return;

	const links = wrapper.querySelectorAll('a[href^="#"]');

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const href = link.getAttribute('href');
			const target = document.querySelector(href);
			if (!target) return;

			const rect = target.getBoundingClientRect();
			scrollTo(0, customPageScroll.scrollY + rect.top, 700);
		});
	});

	const formOne = document.querySelector('[data-contact-form-one]');
	const formTwo = document.querySelector('[data-contact-form-two]');
	const container = document.querySelector('.contact-hero__container');

	if (!formOne || !formTwo || !container) {
		console.warn('One or more form elements are missing.');
		return;
	}

	// Set initial visibility and position
	gsap.set(formTwo, { x: '100%', autoAlpha: 0 });

	function adjustHeight(targetForm) {
		if (!targetForm) return;

		const targetHeight = targetForm.offsetHeight;
		gsap.to(container, { height: targetHeight, duration: 0.5 });
	}

	const rfpButton = document.querySelector('[data-rfp-button]');
	const rfpBackButton = document.querySelector('[data-rfp-back-button]');

	if (rfpButton) {
		rfpButton.addEventListener('click', () => {
			gsap.to(formOne, { x: '-100%', autoAlpha: 0, duration: 0.5 });
			gsap.to(formTwo, { x: '0%', autoAlpha: 1, duration: 0.5, onComplete: () => adjustHeight(formTwo) });
		});
	} else {
		console.warn('RFP button not found.');
	}

	if (rfpBackButton) {
		rfpBackButton.addEventListener('click', () => {
			gsap.to(formTwo, { x: '100%', autoAlpha: 0, duration: 0.5 });
			gsap.to(formOne, { x: '0%', autoAlpha: 1, duration: 0.5, onComplete: () => adjustHeight(formOne) });
		});
	} else {
		console.warn('RFP back button not found.');
	}

	// Initial height adjustment for the first form
	adjustHeight(formOne);
};
